// extracted by mini-css-extract-plugin
export default {"root":"WaveSwiper_root__hh2rg","swiper-slide":"WaveSwiper_swiper-slide__oFJUl","left":"WaveSwiper_left__2vBZY","right":"WaveSwiper_right__TEGk0"};